import React, { useEffect, useState } from "react";
import CommonUtil from "../../../utils/commonUtil";

const MonthRangePicker = (props) => {

  
  const months = [
    { name: "Ene", value: 0 }, { name: "Feb", value: 1 }, { name: "Mar", value: 2 },
    { name: "Abr", value: 3 }, { name: "May", value: 4 }, { name: "Jun", value: 5 },
    { name: "Jul", value: 6 }, { name: "Ago", value: 7 }, { name: "Sep", value: 8 },
    { name: "Oct", value: 9 }, { name: "Nov", value: 10 }, { name: "Dic", value: 11 }
  ];

  const [selectedRange, setSelectedRange] = useState({ start: null, end: null });
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    if (props.startDate && props.endDate) {
      const startMonth = new Date(props.startDate).getMonth();
      const startYear = new Date(props.startDate).getFullYear();
      const endMonth = new Date(props.endDate).getMonth();
      const endYear = new Date(props.endDate).getFullYear();

      setSelectedRange({
        start: { month: startMonth, year: startYear },
        end: { month: endMonth, year: endYear },
      });
    } else {
      setSelectedRange({ start: null, end: null });
    }
  }, [props.startDate, props.endDate]);

  const handleMonthClick = (monthValue) => {
    const selected = { month: monthValue, year };
    if (!selectedRange.start) {
      setSelectedRange({ start: selected, end: null });
    } else if (!selectedRange.end) {
      const startDate = new Date(selectedRange.start.year, selectedRange.start.month);
      const endDate = new Date(selected.year, selected.month);

      if (startDate.getTime() === endDate.getTime()) {
        setSelectedRange({ start: null, end: null });
        props.setStartDateAndEndDate({ start: "", end: "", startMonthName: "", endMonthName: "" });
      } else if (endDate > startDate) {
        setSelectedRange({ start: selectedRange.start, end: selected });
      } else {
        setSelectedRange({ start: selected, end: selectedRange.start });
      }
    } else {
      if (selectedRange?.start?.year == selectedRange?.end?.year && selected?.start?.month == selected?.end?.month) {
         setSelectedRange({ start: null, end: null });
         props.setStartDateAndEndDate({start: "",end: "",startMonthName: "",endMonthName: ""});
      }
      setSelectedRange({ start: selected, end: null });
    }
  };

  const applyRange = () => {
    if (selectedRange.start) {
      const { month: startMonth, year: startYear } = selectedRange.start;
      const { month: endMonth, year: endYear } = selectedRange.end || selectedRange.start;

      const startMonthName = months.find((i) => i.value === startMonth)?.name;
      const endMonthName = months.find((i) => i.value === endMonth)?.name;

      const startDate = new Date(startYear, startMonth, 1);
      const endDate = new Date(endYear, endMonth + 1, 0);

      if (props.isWapSearch) {
        props.submit({ startDate: startDate.toLocaleDateString("en-CA"), endDate: endDate.toLocaleDateString("en-CA") }, 'eventDate');
      }

      props.setStartDateAndEndDate({
        start: startDate.toLocaleDateString("en-CA"),
        end: endDate.toLocaleDateString("en-CA"),
        startMonthName: `${startMonthName}-${startYear}`,
        endMonthName: `${endMonthName}-${endYear}`,
      });
    } else {
      if (props.isWapSearch) {
        props.submit({ startDate: "", endDate: "" }, 'eventDate');
      }
      props.setStartDateAndEndDate({ start: "", end: "", startMonthName: "", endMonthName: "" });
    }
    props.enableMonthRangePicker();
  };

  const isSameMonth = (a, b) => a?.month === b?.month && a?.year === b?.year;

  const isInRange = (monthValue, y) => {
    if (!selectedRange.start || !selectedRange.end) return false;
    const date = new Date(y, monthValue);
    const start = new Date(selectedRange.start.year, selectedRange.start.month);
    const end = new Date(selectedRange.end.year, selectedRange.end.month);
    return date >= start && date <= end;
  };

  const isStart = (monthValue, y) => isSameMonth(selectedRange.start, { month: monthValue, year: y });
  const isEnd = (monthValue, y) => isSameMonth(selectedRange.end, { month: monthValue, year: y });

  const currentDate = new Date();
  const currentMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const minAllowedDate = new Date(currentMonthDate);
  minAllowedDate.setFullYear(minAllowedDate.getFullYear() - 1);
  const maxAllowedDate = new Date(currentMonthDate);
  maxAllowedDate.setFullYear(maxAllowedDate.getFullYear() + 1);

  return (
    <div  className="month-range-picker-main-container">
      <div className="month-header">
        <img src={CommonUtil.getAssetURL() + "/images/Back.svg"} onClick={() => setYear(year - 1)} />
        <p style={{ fontSize: 14, fontWeight: 600 }} className="wap-calendar-header">{`Año ${year}`}</p>
        <img src={CommonUtil.getAssetURL() + "/images/Next.svg"} onClick={() => setYear(year + 1)} />
      </div>

      <div className="month-picker-grid">
        {months.map((month,index) => {
          const isRange = isInRange(month.value, year);
          const isStartMonth = isStart(month.value, year);
          const isEndMonth = isEnd(month.value, year);

          const monthDate = new Date(year, month.value, 1);
          const isDisabled = monthDate < minAllowedDate || monthDate > maxAllowedDate;
          const isMiddle = isRange && !isStartMonth && !isEndMonth;
          
          return (
            <div
              key={month.value}
              style={{
                backgroundColor: isMiddle ? "#FCE6F5" : "transparent",
                ...(isStartMonth && selectedRange.end && !isSameMonth(selectedRange.start, selectedRange.end)) && {
                  background: "linear-gradient(to right, #ffffff 0% 50%,rgb(252, 230, 245) 50% 100%)"
                },
                ...(isEndMonth && !isSameMonth(selectedRange.start, selectedRange.end)) && {
                  background: "linear-gradient(to left, #ffffff 0% 50%,rgb(252, 230, 245) 50% 100%)"
                },
                ...(isStartMonth && isEndMonth) && { background: "#ffffff" }
              }}
              className="month-picker-grid-item"
            >
              <div
                onClick={() => !isDisabled && handleMonthClick(month.value)}
                style={{
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  backgroundColor: isStartMonth || isEndMonth ? "var(--main-color-brand)" : "transparent",
                  color: isDisabled ? "#ccc" : isStartMonth || isEndMonth ? "white" : "#333",
                  borderRadius: isStartMonth ? "50%" : isEndMonth ? "50%" : "0",
                  opacity: isDisabled ? 0.5 : 1,
                  pointerEvents: isDisabled ? "none" : "auto",
                 
                }}
                className="month-picker-text-item"
              >
                {month.name}
              </div>
            </div>
          );
        })}
      </div>

      <div
        onClick={selectedRange.start ? applyRange : undefined}
        className="month-picker-button"
        style={{
          backgroundColor: CommonUtil.getChannel() === "wap" ? (selectedRange.start ? "var(--main-color-brand)" : "#D8D8D8") : "#fff",
          borderColor:`${selectedRange.start ? "var(--main-color-brand)" : "#D8D8D8"}`,
         
          cursor: selectedRange.start ? "pointer" : "not-allowed",
          color: CommonUtil.getChannel() === "wap" ? "#fff" : (selectedRange.start ? "var(--main-color-brand)" : "#D8D8D8"),
          opacity: selectedRange.start ? 1 : 0.5,
          pointerEvents: selectedRange.start ? "auto" : "none",
        }}
      >
        Aplicar
      </div>
    </div>
  );
};

export default MonthRangePicker;
